export default {
  ANONYMOUS: "ANONYMOUS",
  PUBLIC: "PUBLIC",
  PRIVATE: "PRIVATE",
};
